import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";

export const GroupedLinksColumnMobileContainer = styled(Grid)(({ theme }) => ({
  padding: theme.spacing(0),
}));
